import combinedReducers from "reducers";
import { applyMiddleware, compose, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createPromise } from "redux-promise-middleware";
import createSagaMiddleware from "redux-saga";
import rootSaga from "sagas";

const sagaMiddleware = createSagaMiddleware();
/**
|--------------------------------------------------
| Put reducers to local storage
| Do not store form to local storage
|--------------------------------------------------
*/
const reducer = persistReducer(
    { key: "state", storage, whitelist: ["workspaces"] },
    combinedReducers
);

//  Preparing middleware for store
let middleware = null;
if (process.env.REACT_APP_REDUX_DEBUGGER === "true") {
    middleware = composeWithDevTools(applyMiddleware(createPromise(), sagaMiddleware));
} else {
    middleware = compose(applyMiddleware(createPromise(), sagaMiddleware));
}

//  Prepare store for Provider
const store = createStore(reducer, middleware);

//  Mount sagas
sagaMiddleware.run(rootSaga);

//  Prepare persistor for persistStore
const persistor = persistStore(store);

//  Exporting store and persistor for providers in index
export { persistor, store };
